import React from 'react';
import * as action from '../Actions';
import Service from '../../service/Service';
const service = new Service();

export default function ({ catg, eleRef }) {
    console.log("eleRefeleRefeleRef===",eleRef.props.location.pathname)

    let ListTemplate;
      if (eleRef.props.location.pathname.split("?")[0].split('/').length==5) {
        ListTemplate = catg.subcategory && catg.subcategory.map((subcat, index) => {
            const imgUrl = subcat.imgUrl && subcat.imgUrl.endsWith(".jpg") 
            ? subcat.imgUrl.replace(".jpg", ".webp") 
            : subcat.imgUrl;
            return(
                <li key={index} className="subcatg">
                    <button
                        type="button"
                        className="subcatg-button"
                        aria-label={`View details for ${subcat.subcategoryName}`}
                        onClick={() => action.gotoDetailsPage(service.replaceSymbols(eleRef.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(eleRef.props.location.pathname.split("?")[0].split('/')[3]), service.replaceSymbols(subcat.subcategoryName),subcat.subcategoryId)}
                    >
                    <div className="coloring-img">
                    {imgUrl ? (
                            <img
                                src={imgUrl}
                                onError={(e) => {
                                    e.target.src = '/media/default-placeholder.png';
                                }}
                                alt={subcat.subcategoryName}
                                title={subcat.subcategoryName}
                                className="dev_cat_img"
                            />
                        ) : (
                            <img
                                src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'}
                                alt={subcat.subcategoryName}
                                title={subcat.subcategoryName}
                                className="dev_cat_img"
                            />
                        )}
                        {/* {subcat.imgUrl ?
                            <img src={subcat.imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={`${subcat.subcategoryName}`} title={`${subcat.subcategoryName}`} className="dev_art_imgsel"/>
                            :
                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={`${subcat.subcategoryName}`} title={`${subcat.subcategoryName} `} className="dev_art_imgsel"/>
                        } */}
                    </div>
                    <div className="img-name">
                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Coloring-Bottom-Design.png'} alt=''></img>
                        {/* <svg viewBox="0 0 40 10">
                            <path d="M0 0 V 11 H 40 V 11 L 40 -2 Q 20 5, 0 0"></path>
                            <path d="M0 0 V 11 H 40 V 10 L 40 0 Q 20 5, 0 0"></path>
                        </svg> */}
                        <div className="dev_art_nmsel">{subcat.subcategoryName}</div>
                    </div>
                    </button>
                </li>
            )
        }
            
          );
      } else {
        ListTemplate = catg.subcategory.map((subcat, index) => {
            const imgUrl = subcat.imgUrl && subcat.imgUrl.endsWith(".jpg") 
                ? subcat.imgUrl.replace(".jpg", ".webp") 
                : subcat.imgUrl;
    
            return (
                <li key={index} className="subcatg">
                   <button
                        type="button"
                        className="subcatg-button"
                        aria-label={`View details for ${subcat.subcategoryName}`}
                        onClick={() => action.gotoSubCatDetail(
                    service.replaceSymbols(
                        (eleRef.props.location.pathname.split("?")[0].split('/')[2] != "") 
                            ? eleRef.props.location.pathname.split("?")[0].split('/')[2]
                            : (eleRef.state.selectedCatAry && eleRef.state.selectedCatAry[0] && eleRef.state.selectedCatAry[0].categoryName) 
                                ? eleRef.state.selectedCatAry[0].categoryName 
                                : catg.categoryName
                    ),
                    service.replaceSymbols(subcat.subcategoryName),
                    eleRef,
                    subcat.isSubCatData
                )} 
                    >
                    <div className="coloring-img">
                        {imgUrl ? (
                            <img
                                src={imgUrl}
                                onError={(e) => {
                                    e.target.src = '/media/default-placeholder.png';
                                }}
                                alt={subcat.subcategoryName}
                                title={subcat.subcategoryName}
                                className="dev_cat_img"
                            />
                        ) : (
                            <img
                                src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'}
                                alt={subcat.subcategoryName}
                                title={subcat.subcategoryName}
                                className="dev_cat_img"
                            />
                        )}
                    </div>
                    <div className="img-name">
                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Coloring-Bottom-Design.png'} alt="" />
                        <div className="dev_cat_nm">{subcat.subcategoryName}</div>
                    </div>
                    </button>
                </li>
            );
        });
    }
    
      
    //   else {
    //     ListTemplate = catg.subcategory.map((subcat, index) =>
    //         const imgUrl = subcat.imgUrl.endsWith(".jpg") 
    //         ? subcat.imgUrl.replace(".jpg", ".webp") 
    //         : subcat.imgUrl;
    //             <li key={index} className="subcatg 34" onClick={() => action.gotoSubCatDetail(service.replaceSymbols((eleRef.props.location.pathname.split("?")[0].split('/')[2]!="")?eleRef.props.location.pathname.split("?")[0].split('/')[2]:(eleRef.state.selectedCatAry && eleRef.state.selectedCatAry[0] && eleRef.state.selectedCatAry[0].categoryName)?eleRef.state.selectedCatAry[0].categoryName:catg.categoryName),service.replaceSymbols(subcat.subcategoryName),eleRef,subcat.isSubCatData)}>
    //                 <div className="coloring-img">
    //                     {subcat.imgUrl ?
    //                         <img src={subcat.imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={`${subcat.subcategoryName} Colouring Pages`} title={`${subcat.subcategoryName} Colouring Pages`} className="dev_cat_img"/>
    //                         :
    //                         <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={`${subcat.subcategoryName} Colouring Pages`} title={`${subcat.subcategoryName} Colouring Pages`} className="dev_cat_img"/>
    //                     }
    //                 </div>
    //                 <div className="img-name">
    //                     <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Coloring-Bottom-Design.png'}></img>
    //                     {/* <svg viewBox="0 0 40 10">
    //                         <path d="M0 0 V 11 H 40 V 11 L 40 -2 Q 20 5, 0 0"></path>
    //                         <path d="M0 0 V 11 H 40 V 10 L 40 0 Q 20 5, 0 0"></path>
    //                     </svg> */}
    //                     <div className="dev_cat_nm">{subcat.subcategoryName}</div>
    //                 </div>
    //             </li>
    //       );
    //   }

    return (
        <ul className="subcategory-list">
            {ListTemplate}
        </ul>
    )
}
